import { Yup } from "lib/extendYup";

export const roleDetailsValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  permissions: Yup.array().min(1, "Please check at least one"),
});
